import { container } from '../../../../../../diContainer';
import { ACDLError } from '../../../../../models/error.model';
import { IMainApiService } from '../../../../../services/api.service';
import { IAnnotationResponse } from '../../../annotations.interface';
import { IQuestionDto } from '../../../question.model';
import { IAnnotationType } from '../../annotationTypes/models/annotationType';

export interface IImageAnnotationsResponse {
  projects: { id: string; name: string }[];
  emptyProjects: { id: string; name: string }[];
  annotations: IAnnotationResponse[];
  annotationTypes: IAnnotationType[];
  questions: IQuestionDto[];
}

export interface ISegmentationsApiService {
  peekImageAnnotations(imageId: string): Promise<IImageAnnotationsResponse | ACDLError>;
}

export const useSegmentationsApiService = (): ISegmentationsApiService => {
  const api = container.get<IMainApiService>(IMainApiService.$);

  const peekImageAnnotations = async (imageId: string): Promise<IImageAnnotationsResponse | ACDLError> =>
    api.getAsync(`/Images/PeekImageAnnotations?imageId=${imageId}`);

  return {
    peekImageAnnotations,
  };
};
